import { memo } from 'react'
import { Message } from '../../../../../../types/mfc'
import PMChatSystemPM from './PMChatSystemPM'
import PMChatUserPM from './PMChatUserPM'

type PMChatRowProps = {
    myColors: any
    theirColors: any
    message: Message
    id: number
    isFullWindow: boolean
}

const PMChatRow = memo((props: PMChatRowProps) => {
    const { myColors, theirColors, message, id, isFullWindow } = props
    const { warning, success, error, info } = message

    if (warning || success || error || info) {
        return <PMChatSystemPM message={message} id={id} />
    }

    return (
        <PMChatUserPM
            message={message}
            myColors={myColors}
            theirColors={theirColors}
            isFullWindow={isFullWindow}
        />
    )
})

export default PMChatRow
